import React from 'react';
import { Button } from 'react-bootstrap';
import { ListItemHeader, ListItemDivider, ListItemCheck } from '../../atoms';
import { BtnWithDropdown, IconWithDropdown } from '..';
import styles from './selectedActions.module.scss';
import { useI18N } from '../../../hooks';

interface Props {
    iconOnly?: boolean;
    count?: number;
    small?: boolean;
    large?: boolean;
    className?: string;
    classNameDropdown?: string;
    totalCount?: number;
    selectAllLabel?: string;
    onChange?: (value: React.FormEvent<HTMLInputElement>) => void;
    onShowAllChange?: (isChecked: boolean) => void;
    onSelectAllChange?: (isChecked: boolean) => void;
    onUnselectClick?: () => void;
    disabled?: boolean;
}
export default function SelectedActions({ iconOnly, small, large, className, classNameDropdown, count, onSelectAllChange, onShowAllChange, totalCount, onUnselectClick, selectAllLabel, disabled }: Props) {
    const i18n = useI18N();
    const size = (small) ? 'sm' : (large) ? 'lg' : undefined;
    const [selectAllChecked, setSelectAllChecked] = React.useState(false);
    const [showAllChecked, setShowAllChecked] = React.useState(false);

    const onSelectAll = (value: React.FormEvent<HTMLInputElement>) => {
        const isChecked = (value.target as any)?.checked || false;
        if (isChecked) {
            setSelectAllChecked(true);
            if (onSelectAllChange) {
                onSelectAllChange(isChecked);
            }
        }
        else {
            setSelectAllChecked(false);
            if (onSelectAllChange) {
                onSelectAllChange(isChecked);
            }
        }
    }

    const onShowAll = (value: React.FormEvent<HTMLInputElement>) => {
        const isChecked = (value.target as any)?.checked || false;
        if (isChecked) {
            setShowAllChecked(true);
            if (onShowAllChange) {
                onShowAllChange(isChecked);
            }
        }
        else {
            setShowAllChecked(false);
            if (onShowAllChange) {
                onShowAllChange(isChecked);
            }
        }
    }

    const onUnselect = () => {
        if (onUnselectClick) {
            onUnselectClick();
        }
    }

    //checks to make sure select all is false when at least one row is selected
    React.useEffect(() => {
        if (count !== undefined && totalCount) {
            if (count < totalCount || count === 0) {
                setSelectAllChecked(false);
            }
        }
    }, [count, totalCount]);

    //checks to make sure show all is false when no rows are selected
    React.useEffect(() => {
        if (count !== undefined) {
            if (count === 0) {
                setShowAllChecked(false);
            }
        }
    }, [count]);

    const DropdownMenu = () => (
        <>
            <ListItemHeader text={ i18n.translateThis('Selected', i18n.localize.selectedActions.selected) + `: ${count}`} />
            <ListItemDivider />
            {
                (onShowAllChange) ?
                    <ListItemCheck
                        label={i18n.translateThis('Show Selected Only', i18n.localize.selectedActions.showSelectedOnly)}
                        isChecked={showAllChecked}
                        value={'show_selected_only'}
                        onChange={(value) => onShowAll(value)}
                    /> : null
            }
            {
                (onSelectAllChange) ?
                    <ListItemCheck
                        label={(selectAllLabel) ? selectAllLabel : i18n.translateThis('Select All', i18n.localize.selectedActions.selectAll)}
                        isChecked={selectAllChecked}
                        value={'select_all'}
                        onChange={(value) => onSelectAll(value)}
                    /> : null
            }
            <ListItemDivider />
            <div className='d-flex justify-content-end pr-3'>
                <Button size={'sm'} variant="link" onClick={onUnselect}>{ i18n.translateThis('Clear All', i18n.localize.selectedActions.clearAll )}</Button>
            </div>
        </>
    )

    return (
        <>
            {
                (iconOnly) ?

                    <IconWithDropdown
                        icon={<i className={`fas fa-check-square text-info ${styles.iconOnly}`} style={{ opacity: (disabled) ? .50 : 1 }}></i>}
                        className={`${className}`}
                        classNameToggle={'pt-0 pr-2'}
                        caret
                        drop={'down'}
                        text={ i18n.translateThis('Selected', i18n.localize.selectedActions.selected) }
                        toolTip={false}
                        classNameDropdown={`${styles.dropdown} ${classNameDropdown}`}
                        disabled={disabled}
                    >
                        <DropdownMenu />
                    </IconWithDropdown>

                    :
                    <BtnWithDropdown
                        counter={count}
                        small={(size === 'sm') ? true : false}
                        large={(size === 'lg') ? true : false}
                        variant={'info'}
                        label={ i18n.translateThis('Selected', i18n.localize.selectedActions.selected) }
                        icon={<i className="fas fa-check-square text-white"></i>}
                        className={className}
                        caret
                        caretDir={'down'}
                        classNameDropdown={`${styles.dropdown} ${classNameDropdown}`}
                        disabled={disabled}
                    >
                        <DropdownMenu />
                    </BtnWithDropdown>
            }
        </>
    )
}